export default __webpack_public_path__ + "static/media/dynamic-grid.4c1c1a28.png";